import React, { useState } from "react";
import { FiX, FiPlus, FiTrash2 } from "react-icons/fi";

// Whitelist management overlay. Lets the user add/remove domains that are
// auto-allowed for outbound requests and beacons.
//
// whitelist shape: { "example.com": { allowSend: bool, allowBeacon: bool, addedAt: number } }
export default function WhitelistSettings({ whitelist, onChange, texts, onClose }) {
  const t = texts && texts.network ? texts.network : null;
  const L = {
    title: (t && t.whitelistTitle) || "通信許可リスト",
    subtitle: (t && t.whitelistSubtitle) || "ここで許可したドメインは、次回以降モーダルなしで許可されます。",
    domainLabel: (t && t.domain) || "ドメイン",
    send: (t && t.send) || "送信",
    beacon: (t && t.beacon) || "Beacon",
    add: (t && t.add) || "追加",
    close: (t && t.closeAria) || "閉じる",
    empty: (t && t.whitelistEmpty) || "許可済みドメインはありません",
    placeholder: (t && t.whitelistPlaceholder) || "example.com"
  };

  const [draft, setDraft] = useState("");

  const normalize = (s) => s.trim().toLowerCase().replace(/^https?:\/\//, "").replace(/\/.*$/, "");

  const addDomain = () => {
    const d = normalize(draft);
    if (!d || whitelist[d]) { setDraft(""); return; }
    onChange({ ...whitelist, [d]: { allowSend: true, allowBeacon: false, addedAt: Date.now() } });
    setDraft("");
  };

  const remove = (d) => {
    const next = { ...whitelist };
    delete next[d];
    onChange(next);
  };

  const toggle = (d, key) => {
    const cur = whitelist[d];
    if (!cur) return;
    onChange({ ...whitelist, [d]: { ...cur, [key]: !cur[key] } });
  };

  const entries = Object.entries(whitelist);

  return (
    <div className="wls-overlay" role="dialog" aria-modal="true">
      <div className="wls-modal">
        <button className="wls-close" aria-label={L.close} onClick={onClose}><FiX /></button>
        <h3 className="wls-title">{L.title}</h3>
        <p className="wls-subtitle">{L.subtitle}</p>

        <div className="wls-add-row">
          <input
            type="text"
            value={draft}
            placeholder={L.placeholder}
            onChange={(e) => setDraft(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") addDomain(); }}
          />
          <button className="wls-add-btn" onClick={addDomain}><FiPlus /> {L.add}</button>
        </div>

        <div className="wls-list">
          {entries.length === 0 ? (
            <div className="wls-empty">{L.empty}</div>
          ) : entries.map(([d, cfg]) => (
            <div key={d} className="wls-row">
              <span className="wls-domain" title={d}>{d}</span>
              <label className="wls-check" title={L.send}>
                <input type="checkbox" checked={!!cfg.allowSend} onChange={() => toggle(d, "allowSend")} />
                <span>{L.send}</span>
              </label>
              <label className="wls-check" title={L.beacon}>
                <input type="checkbox" checked={!!cfg.allowBeacon} onChange={() => toggle(d, "allowBeacon")} />
                <span>{L.beacon}</span>
              </label>
              <button className="wls-remove" onClick={() => remove(d)} aria-label="remove"><FiTrash2 /></button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}